import { InjectionToken } from "@angular/core";
import { HttpInterceptor, HttpContextToken } from "@angular/common/http";

/**
 * Injection token for the formationApi client base API path
 */
export const BASE_PATH_FORMATIONAPI = new InjectionToken<string>('BASE_PATH_FORMATIONAPI', {
    providedIn: 'root',
    factory: () => '/api', // Default fallback
});
/**
 * Injection token for the formationApi client HTTP interceptor instances
 */
export const HTTP_INTERCEPTORS_FORMATIONAPI = new InjectionToken<HttpInterceptor[]>('HTTP_INTERCEPTORS_FORMATIONAPI', {
    providedIn: 'root',
    factory: () => [], // Default empty array
});
/**
 * HttpContext token to identify requests belonging to the formationApi client
 */
export const CLIENT_CONTEXT_TOKEN_FORMATIONAPI = new HttpContextToken<string>(() => 'formationApi');
